import N from 'utils-support/navigation'
import SupportListWrapper from 'core/page/SupportListWrapper'
import { IBankHoliday } from '@cbgms/api/modules/bank-holidays'
import { listBankHolidays } from '../state/actions'

export const onAdd = () => {
  N.push('/bank-holidays/new')
}

export const onEdit = (data: { BankHoliday: IBankHoliday }) => {
  N.push(`/bank-holidays/edit/${data.BankHoliday.UUID}`)
}

const BankHolidaysList = () => {
  return (
    <SupportListWrapper
      scope='bank-holidays'
      onAdd={onAdd}
      onEdit={onEdit}
      loadAction={listBankHolidays}
      UseApiSearchSettings
      translationKey='bank_holiday'
    />
  )
}

export default BankHolidaysList
